import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { History } from "history";
import logoImage from "../images/logo.png";
import Form from "../components/forms/RestorePassword";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

interface Props {
  history: History;
}

const ResetPasswordPage: React.FC<Props> = ({ history }) => {
  const { token } = useParams();
  const query = useQuery();
  const email = query.get("email") as string;

  return (
    <div className="login-page">
      <div className="login-page__card">
        <img
          src={logoImage}
          alt={`${process.env.REACT_APP_NAME} logo`}
          className="login-page__logo"
        />
        <Form token={token} email={email} history={history} />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
